import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

import collapseIcon from '../../Icons/Normal/Subsections/collapse-icon.png'
import expandIcon from '../../Icons/Normal/Subsections/expand-icon.png'

export const HowContainerDiv = styled(BaseStyles.Div)`
    padding: 1.2rem 2rem;
`

export const HowContainerContentsDiv = styled(BaseStyles.Div)`
    margin: 0rem auto;
    min-width: 20rem;
    max-width: 140rem;      
`

export const HowContentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;   
    background-color: white;
    border-radius: 1.5rem;
    padding: 1.2rem;
`

export const HowRowContents = styled(BaseStyles.Div)`
    width: 100%;
    overflow: hidden;
`

export const HowLeftContent = styled(BaseStyles.Div)`
    width: 50%;
    float: left;
`

export const HowRightContent = styled(BaseStyles.Div)`
    width: 50%;
    float: right;
`

export const HowSectionHeader = styled(BaseStyles.SectionHeader)`
    color: black;
    overflow: initial;
`

export const HowStepsContainer = styled(BaseStyles.Div)`
    margin: 0;
    padding: 1.2rem 0rem;
    width: 100%;
    overflow: hidden;
`

export const HowSteps = styled.h3`
    margin: 0;
    padding: 0;
    font-size: 1.5rem;
    float: left;
`

export const HowDetailsSection = styled(BaseStyles.Div)`
    width: 100%;
    padding: 0rem 1.5rem;
`

export const HowDetails = styled.h3`
    margin: 0;
    padding: 0;
    font-size: 1.3rem;
    font-weight: 550;
`

export const CollapseButton = styled(BaseStyles.IconButton)`
    background-image: url(${collapseIcon});
    margin-right: 0.5rem;
    width: 1.8rem;
    height: 1.8rem;
    float: right;
    cursor: pointer;
`

export const ExpandButton = styled(BaseStyles.IconButton)`
    background-image: url(${expandIcon});
    margin-right: 0.5rem;
    width: 1.8rem;
    height: 1.8rem;
    float: right;
    cursor: pointer;
`

export const InlineLink = styled.span`
    margin: 0;
    padding: 0;
    color: black;
    font-size: 1.3rem;
    text-decoration: underline;
    cursor: pointer;
`